import { apiEndPoint, header } from 'config';
import { handleResponse } from 'helpers';
import { userStorage, authHeader } from 'helpers';
import { apiConstants } from '../constants';
import { queryFilters, queryWhere } from '../helpers/util';

export const accountService = {
  isLoginActive,
  login,
  register,
  logout,

  getProfile,
  getAccountType,
  getAllAccountTypes,
  getAllCustomerAccountTypes,
  getAllAccounts,
  getAccount,
  getAllByCustomer,

  checkToken,

  addInterimAccount,
  addCustomerAccount,

  updateAccount,
  updateProfile,
  updatePassword,
  resetPassword,
  forgotPassword,

  deleteAccount,
  deleteOwnAccount
};

function isLoginActive() {
  return userStorage.hasUser();
}

function login(email, password) {
  const requestOptions = {
    method: 'POST',
    headers: header,
    body: JSON.stringify({ email, password })
  };

  return fetch(`${apiEndPoint.apiUrl}/account/login`, requestOptions)
    .then(handleResponse);
}

function register(registration) {
  const requestOptions = {
    method: 'POST',
    headers: header,
    body: JSON.stringify(registration)
  };

  return fetch(apiConstants.register, requestOptions)
    .then(handleResponse);
}

function logout() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader()
  };
  userStorage.removeUser();
  // return fetch(`${apiEndPoint.apiUrl}/account/logout`, requestOptions)
  //   .then(handleResponse);
}

function getProfile() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getProfile;
  return fetch(url, requestOptions)
    .then(handleResponse);

}

function getAccountType(account_type_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  // let user = userStorage.getUser();
  if (account_type_id) {
    var url = apiConstants.getAccountType.replace(':account_type_id', account_type_id)
    return fetch(url, requestOptions)
      .then(handleResponse).catch(error => {
        throw (error);
      });;
  } else return undefined;

}

function getAllAccountTypes(limit, page, filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getAccountTypes;
  var accounttypefilters = queryFilters(limit, page);
  if (filters) accounttypefilters = accounttypefilters.concat('', queryWhere(filters));
  return fetch(`${url}${accounttypefilters}`, requestOptions)
    .then(handleResponse).catch(error => {
      throw (error);
    });
}

function getAllCustomerAccountTypes(limit, page) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getCustomerAccountTypes;
  var filters = queryFilters(limit, page);
  return fetch(`${url}${filters}`, requestOptions)
    .then(handleResponse).catch(error => {
      throw (error);
    });
}

function getAccount(account_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  // let user = userStorage.getUser();
  if (account_id) {
    var url = apiConstants.getAccount.replace(':account_id', account_id)
    return fetch(url, requestOptions)
      .then(handleResponse);
  } else return undefined;

}

function getAllAccounts(limit, page, filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getAllAccounts;
  var accountfilters = queryFilters(limit, page);
  if (filters) accountfilters = accountfilters.concat('', queryWhere(filters));
  return fetch(`${url}${accountfilters}`, requestOptions)
    .then(handleResponse).catch(error => {
      throw (error);
    });
}

function getAllByCustomer(limit, page, filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  var url = apiConstants.getCustomerAccounts
  var accountfilters = queryFilters(limit, page);
  if (filters) accountfilters = accountfilters.concat('', queryWhere(filters));
  var filters = queryFilters(limit, page);
  return fetch(`${url}${accountfilters}`, requestOptions)
    .then(handleResponse);
}


function checkToken(token) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  var url = apiConstants.checkToken.replace(':token', token);
  return fetch(`${url}`, requestOptions)
    .then(handleResponse);
}

function addInterimAccount(newValues) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(newValues)
  };
  var url = apiConstants.addInterimAccount;
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function addCustomerAccount(newValues) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(newValues)
  };
  var url = apiConstants.addCustomerAccount;
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function updateProfile(updatedValues) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(updatedValues)
  };
  var url = apiConstants.updateProfile;
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function updateAccount(account_id, updatedValues) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(updatedValues)
  };
  var url = apiConstants.putAccount.replace(':account_id', account_id);
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function updatePassword(updatedValues) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(updatedValues)
  };
  var url = apiConstants.updatePassword;
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function resetPassword(token, updatedValues) {
  const requestOptions = {
    method: 'POST',
    headers: header,
    body: JSON.stringify(updatedValues)
  };
  var url = apiConstants.resetPassword.replace(':token', token);
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function forgotPassword(email) {
  const requestOptions = {
    method: 'GET',
    headers: header
  };
  var url = apiConstants.forgotPassword.replace(':email', email);
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function deleteAccount(account_id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };
  var url = apiConstants.deleteAccount.replace(':account_id', account_id);
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function deleteOwnAccount(password) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    body: JSON.stringify({ password: password })
  };
  var url = apiConstants.deleteOwnAccount;
  return fetch(url, requestOptions)
    .then(handleResponse);
}
